import { AxiosResponse } from 'axios';
import store from '../redux/store/store';
import { snackbarActions } from '@/redux';
import { t } from '@localization/i18n';

export const responseInterceptor = (
  response: AxiosResponse<any, any>,
): AxiosResponse<any, any> => {
  const methods = ['post', 'put', 'delete'];
  const suppressSnackbar = response.config.customConfig?.suppressSnackbar;

  if (
    response?.status === 200 &&
    methods.includes(response.config.method?.toLowerCase() ?? '') &&
    !suppressSnackbar
  ) {
    store.dispatch(
      snackbarActions.openSnackbar({
        message: t('error.success_snackbar_message'),
        severity: 'success',
        autoHideDuration: 2500,
      }),
    );
  }

  return response;
};
